module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<thead>\n  <tr role="row">\n    <th class="sorting_disabled docsFirstCol">Content</th>\n    <th class="sorting_disabled docsSecCol">_key</th>\n    <th class="sorting_disabled docsThirdCol">\n      <a id="addDocumentButton" class="pull-right addButton"><span class="arangoicon icon_arangodb_roundplus" title="Add a document"></span></a>\n    </th>\n  </tr>\n</thead>\n<tbody>\n  <tr class="odd">\n    <td valign="top" class="dataTables_empty">Loading...</td>\n  </tr>\n</tbody>\n';
}
return __p;
};
